import { ADMIN_SOCKET_URL, THERAPIST_SOCKET_URL } from "config/constants";

export const SOCKET_SERVERS = {
  admin: ADMIN_SOCKET_URL,
  therapist: THERAPIST_SOCKET_URL,
};

export const NOTIFICATION_SOCKET_EVENTS = {
  unreadCount: "notification:unread_count",
  newNotification: "notification:new",
  authExpired: "auth:expired",
};
